import { render } from "./NewWordPage.vue?vue&type=template&id=805a8d40&scoped=true"
import script from "./NewWordPage.vue?vue&type=script&lang=js"
export * from "./NewWordPage.vue?vue&type=script&lang=js"

import "./NewWordPage.vue?vue&type=style&index=0&id=805a8d40&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-805a8d40"]])

export default __exports__